import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const lngs = {
  en: { nativeName: "English" },
  am: { nativeName: "አማርኛ" },
};
const SelectLanguage = () => {
  const { i18n } = useTranslation();
  const handleLanguageChange = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <>
      <div>
        <Form.Control
          as="select"
          size="sm"
          role="button"
          value={i18n.language}
          onChange={(e) => handleLanguageChange(e.target.value)}
        >
          {Object.keys(lngs).map((lng) => (
            <option key={lng} value={lng}>
              {lngs[lng].nativeName}
            </option>
          ))}
        </Form.Control>
      </div>
    </>
  );
};

export default SelectLanguage;
